

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMessageComponent } from '../pages/common-components/custom-message.component';
import { CustomPopupMessageComponent } from '../pages/common-components/custom-popup-message.component';
import { LoadIframeComponent } from '../pages/common-pop-up/load-iframe/load-iframe.component';
import { TotalRecordCountComponent } from '../pages/common-pop-up/total-record-count/total-record-count.component';
import { CommonSidemenuFilterComponent } from '../pages/common-sidemenu-filter/common-sidemenu-filter.component';
import { PipeModule } from './custompipe/pipe.module';
import { MaterialModule } from './material.module';

@NgModule({
  declarations: [
    LoadIframeComponent,
    CommonSidemenuFilterComponent,
    CustomMessageComponent,
    CustomPopupMessageComponent,
    TotalRecordCountComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PipeModule,
    MaterialModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PipeModule,
    LoadIframeComponent,
    CommonSidemenuFilterComponent,
    CustomMessageComponent,
    CustomPopupMessageComponent,
    TotalRecordCountComponent,
  ],
})
export class SharedModule { }
